var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 45,
    viewBox: "0 0 68 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 5.625H56.6667V33.75H11.3333M56.6667 39.375C58.1696 39.375 59.6109 38.7824 60.6736 37.7275C61.7363 36.6726 62.3333 35.2418 62.3333 33.75V5.625C62.3333 2.50312 59.7833 0 56.6667 0H11.3333C8.18833 0 5.66667 2.50312 5.66667 5.625V33.75C5.66667 35.2418 6.26369 36.6726 7.32639 37.7275C8.3891 38.7824 9.83044 39.375 11.3333 39.375H0V45H68V39.375H56.6667Z",
    fill: "#00868E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.ac60b149a3a56683a0a7cdbb853a4450.svg";
export { ForwardRef as ReactComponent };